/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import _ from 'lodash';
import { GridTable } from 'components/reports/base/GridTable';
import styles from '../../styles/components/reports/base/GridTableReport.module.css';
import { StatisticsResults } from 'model/reports/StatisticsResults';

export interface StatisticsTableReportData {
  report: StatisticsResults;
}

export const StatisticsTableReport: React.FC<StatisticsTableReportData> = ({
  report,
}) => {
  return (
    <GridTable
      firstCol={<span className={styles.headerItem}>Item</span>}
      cols={[
        <span key="1" className={styles.headerItem}>
          Average
        </span>,
        <span key="2" className={styles.headerItem}>
          Min
        </span>,
        <span key="3" className={styles.headerItem}>
          Max
        </span>,
        <span key="4" className={styles.headerItem}>
          Total Responses
        </span>,
      ]}
      rows={_.map(report.labels, l => (
        <div>
          <span className={styles.tableItem}>{l}</span>
        </div>
      ))}
      elementRenderer={(colIndex: number, rowIndex: number) => {
        return (
          <>
            {colIndex === 0 && (
              <span className={styles.tableItem}>
                {report.data[rowIndex].avg}
              </span>
            )}
            {colIndex === 1 && (
              <span className={styles.tableItem}>
                {report.data[rowIndex].min}
              </span>
            )}
            {colIndex === 2 && (
              <span className={styles.tableItem}>
                {report.data[rowIndex].max}
              </span>
            )}
            {colIndex === 3 && (
              <span className={styles.tableItem}>
                {report.data[rowIndex].totalResponses}
              </span>
            )}
          </>
        );
      }}
    />
  );
};
